module.exports = __webpack_public_path__ + "static/img/expired.58c2ae7.png";